import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '../../../api/baseURL';

const ReactHelmet = ({ meta_data }) => {
    if (!meta_data) return null;

    const {
        meta_title,
        meta_description,
        meta_keywords,
        og_url,
        og_title,
        og_description,
        og_image,
        twitter_card,
        twitter_url,
        twitter_title,
        twitter_description,
        twitter_image,
        website_title
    } = meta_data;

    const ogImageUrl = `${BASE_URL}${og_image?.url}`;
    const twitterImageUrl = twitter_image?.url ? `${BASE_URL}${twitter_image?.url}` : ogImageUrl;
    const websiteUrl = og_url;

    return (
        <Helmet>
            {/* Title */}
            {website_title && <title>{website_title}</title>}

            {/* Meta Tags */}
            {meta_title && <meta name="title" content={meta_title} />}
            {meta_description && <meta name="description" content={meta_description} />}
            {meta_keywords && <meta name="keywords" content={meta_keywords} />}

            {/* Open Graph / Facebook */}
            {og_url && <meta property="og:url" content={websiteUrl} />}
            {og_title && <meta property="og:title" content={og_title} />}
            {og_description && <meta property="og:description" content={og_description} />}
            {og_image?.url && <meta property="og:image" content={ogImageUrl} />}

            {/* Twitter */}
            {twitter_card && <meta property="twitter:card" content={twitter_card} />}
            {twitter_url && <meta property="twitter:url" content={twitter_url} />}
            {twitter_title && <meta property="twitter:title" content={twitter_title} />}
            {twitter_description && <meta property="twitter:description" content={twitter_description} />}
            {twitter_image?.url && <meta property="twitter:image" content={twitterImageUrl} />}
        </Helmet>
    );
}

export default ReactHelmet;
